<template>
  <div>
    <modals-container name="modal" />
    <div class="train_ba">
      <div style="width: 100%; height: 460px">
        <slider ref="slider" :options="options" v-if="someList && someList.length > 0">
          <!-- 直接使用slideritem slot -->
          <slideritem v-for="(item,index) in someList" :key="index" :style="item.style"></slideritem>
          <!-- 设置loading,可自定义 -->
          <div slot="loading">loading...</div>
        </slider>
      </div>
      <div v-if="token" style="position: relative; width: 1200px; margin: 0 auto; margin-top: -460px; height: 100%;">
        <div class="login_train2">
          <dl>
            <h3>任务中心</h3>
            <p>您有<span> {{courseTask_doing}} </span>个课程任务正在学习<router-link :to="'/continueEdu/taskList/course'" class="b_btn">课程任务</router-link></p>
            <p>您已完成<span> {{studyStatesCounts.plan_completed}} </span>个培训计划任务<router-link :to="'/continueEdu/taskList/plan'" class="b_btn">计划任务</router-link></p>
            <dd>
              <p>您已完成<span> {{courseTask_finished}} </span>个课程任务</p>
              <p>您已获得<span> {{certNum}} </span>个证书</p>
              <!--p>您的总累计学分<span> 25 </span>分</p-->
            </dd>
            <p class="border0"><router-link :to="'/continueEdu/taskList/course'" class="c_btn">进入任务中心</router-link></p>
          </dl>
        </div>
      </div>
    </div>
    <div class="top_tjnews">
      <dl><a href="">发布即时通知、最新内容等信息</a></dl>
    </div>
    <div class="wrap w1200 px_home_news">
      <!--培训信息-->
      <div class="left_in_con">
        <dl>
          <dt>培训信息<span>TRAINING INFORMATION</span><router-link :to="'/continueEdu/trainList'">更多></router-link></dt>
          <dd>
            <p v-for="item in lists1" v-bind:key="item.id" @click="to('/continueEdu/train', item.id)">
              <a>{{item.title}}</a>
              <span>{{ dateFormat(new Date(item.updateDate), 'yyyy-MM-dd') }}</span>
            </p>
          </dd>
        </dl>
      </div>
      <!--/培训信息-->
      <!--新闻资讯-->
      <div class="center_in_con">
        <dl>
          <dt>新闻资讯<span>NEWS INFORMATION</span><router-link :to="'/continueEdu/newsList'">更多></router-link></dt>
          <dd>
            <div v-for="item in lists" v-bind:key="item.id">
              <h4>{{item.title}}
                <router-link :to="'/continueEdu/news/' + item.id" style="color: #e72b12;">
                  [查看详情]
                </router-link><span>{{ dateFormat(new Date(item.updateDate), 'yyyy-MM-dd') }}</span></h4>
              <div v-html="item.content" style="height: 39px; overflow: hidden;"></div>
              <div style="width: 100%; height: 1px; background: #e3e3e3; margin-top: 12px;"></div>
            </div>
          </dd>
        </dl>
      </div>
      <!--/新闻资讯-->
      <!--证书查询-->
      <div class="right_in_con">
        <dl>
          <dt>证书查询</dt>
          <dd>
            <p><span>身份证号码：</span><input v-model="idcard" type="text" /></p>
            <!--p><span>发证日期：</span><input name="" type="text" /></p-->
            <input name="" type="button" value="查询" class="cx_btn" @click="openCertBox" />
          </dd>
          <!--p class="px_emw">
            <img src="@/assets/images/ewm_android.png" /><span>想要了解《经济师继续教育》最新动态，微信扫码关注公众号</span>
          </p-->
        </dl>
      </div>
      <!--/证书查询-->
    </div>
  </div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import ModalBox from '@/components/common/modal/index.vue'
  import InfoBox from '@/components/byl/InfoBox/index.vue'
  import CertBox from '@/components/byl/CertBox/index.vue'
  import rules from '@/utils/validations.js'
  import { getCookie } from '@/store/cookies.js'
  import { slider, slideritem } from 'vue-concise-slider'// import slider components
  import { mapState, mapActions } from 'vuex'
  export default {
    components: { slider, slideritem },
    data () {
      return {
        studyStates: {},
        studyStatesCounts: {},
        imageList: [],
        bannerStyle: { height: '460px' },
        idcard: '', // 证书查询身份证输入
        filters: {
          pageNo: 1,
          pageSize: 3,
          title: '',
          type: '01',
          state: '1',
          audit: '1'
        },
        filters1: {
          pageNo: 1,
          pageSize: 10,
          title: '',
          type: '02',
          state: '1',
          audit: '1'
        },
        someList: [],
        options: {
          currentPage: 0,
          thresholdDistance: 500,
          thresholdTime: 100,
          autoplay: 10000,
          loop: true,
          direction: 'horizontal',
          loopedSlides: 1,
          slidesToScroll: 1,
          timingFunction: 'ease',
          speed: 300,
          renderPagination: (h, index) => {
            return h('span', {
              class: 'b-list-span'
            })
          }
        },
        lists: [],
        lists1: [],
        courseListTask: [],
        courseTask_finished: 0,
        courseTask_doing: 0,
        certNum: '',
        imageData: {},
        certSearchFilters: { // 证书查询条件
          idCard: '',
          certDate: ''
        }
      }
    },
    computed: {
      ...mapState('auth', ['user', 'token'])
    },
    created () {
      this.search(this.filters, '')
      this.search(this.filters1, '1')
      if (this.token) { // 登录后再取
        this.getStudyStates()
        this.getCertNum()
        this.getTasks({ // 取我的课程
          pageNo: 1,
          pageSize: 2,
          itemType: '00'
        }, 'courseListTask')
      }
    },
    mounted () {
      let that = this
      let a = []
      this.getBanners().then(function (r) {
        if (r) {
          r.forEach((o) => {
            let no = {}
            no.style = {
              'background': 'url(' + o.cover + ') no-repeat center center'
            }
            a.push(no)
          })
        }
      })
      that.someList = a
      if (getCookie('user')) {
        if (!getCookie('ifrm_031')) {
          this.hasMemberByUserId(getCookie('user').id).then((r) => {
            if (r) {

            } else { // 没有进入组织结构，提醒用户
              this.showUserInfoBox()
            }
          })
        }
      }
    },
    destroyed () {
    },
    methods: {
      ...mapActions('auth', {
        hasMemberByUserId: 'hasMemberByUserId'
      }),
      ...mapActions('orgstructure', {
        addPerson: 'addPerson'
      }),
      dateFormat: utils.dateFormat,
      getTasks (filters, name) {
        api.post(config.bylApiPath, '/studyItemPermissions/myTasks', filters, (r) => {
          if (r.data) {
            this[name] = r.data.slice(0, 2) // 空间只够容纳2个
            if (name == 'courseListTask') {
              this.courseTask_finished = r.data.filter((o) => {
                return o.per == 100
              }).length
              this.courseTask_doing = r.data.filter((o) => {
                return o.per < 100
              }).length
            }
          } else {
            this[name] = []
          }
        })
      },
      search (filters, t) {
        api.post(config.bylBaseCenterPath, '/noticeinfo/search', filters, (r) => {
          this['lists' + t] = r.data
        })
      },
      getStudyStates () {
        this.$api.post(this.$global.bylApiPath, '/userstate/learningstate', null, r => {
          if (r.data) {
            this.studyStates = r.data
            this.studyStatesCounts = {
              course_finished: this.studyStates.course_finished.length,
              course_unfinished: this.studyStates.course_unfinished.length,
              plan_completed: this.studyStates.plan_completed.length
            }
          }
        })
      },
      getCoursesRecord () {
        this.$api.post(this.$global.courseApiPath, '/course/info/count', null, r => {
          if (r.data) {
            this.coursesRecord = r.data
          }
        })
      },
      getCertNum () {
        this.$api.post(this.$global.bylApiPath, '/cert/certNum', null, r => {
          this.certNum = r.data
        })
      },
      getBanners () {
        var that = this
        return new Promise(function (resolve, reject) {
          that.$api.post(that.$global.bylBaseCenterPath, '/recommendinfo/search', {audit: '1'}, r => {
            resolve(r.data)
          })
        })
      },
      to (path, id) {
        this.$router.push({
          path: path + '/' + id
        })
      },
      showUserInfoBox () {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '完善个人资料',
            styles: {
              width: '670',
              height: String(0.6181 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'infobox',
              template: InfoBox,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: {
                showCheckBox: true
              } // 向组件内传入的数据, 一般用于初始化
            },
            yes (val) { // 点击确认后要做的事情
              if (val) {
                val.data.loginUserId = getCookie('user').id
                if (val.isValidate) {
                  that.addPerson(val.data) // 调用接口保存
                } else {
                  that.$toasted.show('请填写信息')
                  that.showUserInfoBox()
                }
              }
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
            }
          }
        })
      },
      openCertBox () {
        var that = this
        var isIdcard = rules.identification.pattern.test(this.idcard)
        if (that.idcard && isIdcard) {
          this.$modal.show(ModalBox, {
            opts: {
              title: '证书查询结果',
              styles: {
                width: '670',
                height: String(0.6181 * window.screen.availHeight)
              },
              offEdit: true, // 是否包含"确定"与"取消"按钮
              currentComponent: {
                name: 'certbox',
                template: CertBox,
                outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
                inputs: {
                  filters: { idcard: that.idcard }
                } // 向组件内传入的数据, 一般用于初始化
              }
            }
          })
        } else {
          this.$toasted.show('请输入正确身份证号查询证书')
        }
      }
    }
  }
</script>

<style lang="scss">
  .byl-wrap{float:left;/*自适应内容宽度*/position:relative;left:50%;}
  .byl-inner{position:relative;left:-50%;}
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/home.vue